import React, { useEffect, useState } from "react";
import { listCommunityRules } from "../services/timelineService";
import "./CommunityRulesModal.css";

export default function CommunityRulesModal({ open, onClose }) {
  const [loading, setLoading] = useState(true);
  const [rules, setRules] = useState([]);

  useEffect(() => {
    let mounted = true;
    if (!open) return;
    (async () => {
      try {
        const list = await listCommunityRules();
        if (!mounted) return;
        setRules(list);
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => {
      mounted = false;
      setLoading(true);
      setRules([]);
    };
  }, [open]);

  if (!open) return null;

  return (
    <div className="cr-modal">
      <button className="cr-backdrop" onClick={onClose} aria-label="Fechar regras" />
      <div className="cr-inner" role="dialog" aria-modal="true" aria-labelledby="cr-title">
        <header className="cr-head">
          <h3 id="cr-title">Regras da Comunidade</h3>
          <button className="cr-close" onClick={onClose} aria-label="Fechar">×</button>
        </header>

        <div className="cr-body">
          {loading ? (
            <div className="cr-loading">Carregando…</div>
          ) : rules.length === 0 ? (
            <div className="cr-empty">Ainda não há regras cadastradas.</div>
          ) : (
            <div className="cr-grid">
              {rules.map((r, idx) => (
                <article className="cr-card" key={r.id}>
                  <div className="cr-number">{(r.order ?? idx + 1)}</div>
                  <h4 className="cr-title">{r.title}</h4>
                  <p className="cr-text">{r.text}</p>
                </article>
              ))}
            </div>
          )}
        </div>

        <footer className="cr-foot">
          <button className="cr-ok" onClick={onClose}>Entendi</button>
        </footer>
      </div>
    </div>
  );
}